import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Modal,
  Select,
  useMediaQuery,
} from "@mui/material";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  PutAway_MultiUserGetrow,
  SavePutAwayUserAssignment,
} from "../../../Server/ApiV2";
import { useMemo } from "react";
import { fAlertToast } from "../../../Utility/Utilitys";

const MultiUserModal = ({
  open = false,
  fCloseSearchModal = () => {},
  xTitle = "Un-assigned GRN for put-away",
  xVocType = "",
  xVocNo = "",
}) => {
  const vMediaQuery = useMediaQuery("(max-width:850px)");
  const [row, setRow] = useState([
    { id: 1, G_Level: "", G_Level_Name: "", G_Pallet: "", User: "1875" },
    { id: 2, G_Level: "", G_Level_Name: "", G_Pallet: "", User: "1642" },
  ]);
const [userOptions,setUserOptions] = useState([
  // { Uid: "1875", Name1: "ABDUL MAJEED" },
  // { Uid: "2275", Name1: "ADIL EBRAHIM EBRAHIM" },
  // { Uid: "001", Name1: "Administrator" },
  // { Uid: "1642", Name1: "ARSAL KOCHENCHERI SULAIMAN" },
])

  const [isEditing, setIsEditing] = useState(false);
  const column  = useMemo(() =>[
    { field: "G_Level", headerName: "Level", width: 100 },
    {
      field: "G_Level_Name",
      headerName: "Level Name",
      flex: 0.5,
    },
    { field: "G_Pallet", headerName: "Pallet", width: 100 },
    {
      field: "User",
      headerName: "User",
      flex: 1,
      editable: true,

      renderCell: (params) => (
        <Select
          value={params.value || ""}
          displayEmpty
          onChange={(e) => {
            const updatedRows = row.map((r) =>
              r.id === params.row.id ? { ...r, User: e.target.value } : r
            );
            setRow(updatedRows);
          }}
          onFocus={() => setIsEditing(true)}
          onBlur={() => setIsEditing(false)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (r) => r.id === params.row.id
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="User-${nextRow.id}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          inputProps={{
            name: `User-${params.row.id}`,
          }}
          fullWidth
          size="small"
        >
          {userOptions?.map((opt) => (
            <MenuItem key={opt.Uid} value={opt.Uid}>
              {opt.Name1}
            </MenuItem>
          ))}
        </Select>
      ),
    },
  ], [row, userOptions, isEditing]);

  const handleSave = async () => {
    let obj = {
      vocTyp: xVocType,
      vocNo: xVocNo,
      rows: row.map((r) => ({
        G_Level: r.G_Level,
        G_Pallet: r.G_Pallet,
        User: r.User,
      })),
    };

    console.log("Saved Data:", obj);
    let resp = await SavePutAwayUserAssignment(obj);
    if (resp?.status === 200 && resp?.data?.ResultSet?.length == 0) {
      fAlertToast("SUCCESS",'Saved successfully')
    }
   
  };
  const fCheckKey = (event) => {
    if (event.keyCode === 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      if (selectedLength === 0) {
        let tabel = document.getElementById("table-main-grid-4");
        // tabel?.getElementsByClassName("MuiDataGrid-row")[0].firstChild?.click();
        tabel?.getElementsByClassName("MuiDataGrid-row")[0].firstChild?.focus();
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      document.onkeydown = fCheckKey;
    }, 1000);
  }, []);
  // PutAway_MultiUserGetrow
  const getSearch = async (vocType = "", vocNo = "") => {
    let resp = await PutAway_MultiUserGetrow({ vocTyp: vocType, vocNo: vocNo });
 
    if (resp?.status === 200 ) {
      setUserOptions(resp?.data?.ResultSet.UserList)

      let respData =resp?.data?.ResultSet.DataGrid.length ==0?[]: resp?.data?.ResultSet.DataGrid.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setRow(respData);
      
    } else {
      setRow([]);
      setUserOptions([]) 
    }
  };

  useEffect(() => {
    if (open) {
      getSearch(xVocType, xVocNo);
    } else {
      setRow([]);
    }
  }, [open, xVocType, xVocNo]);

  return (
    <Modal
      open={open}
      onClose={fCloseSearchModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCStockTransfer">
          <GCTitleSticky title={xTitle} onClose={fCloseSearchModal} />

          <div className="p-2">
            <Grid container spacing={1} columns={{ xs: 4, sm: 4, md: 12 }}>
              <Grid item xs={12} className="gnr-item-search-label mt-2">
                <div
                  style={{
                    height: vMediaQuery ? "43vh" : "58vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGridPro
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    getRowId={(row) => row.id}
                    rows={row}
                    columns={column}
                    editMode="cell"
                    onCellEditCommit={(params) => {
                      setRow((prevRows) =>
                        prevRows.map((row) =>
                          row.id === params.id
                            ? { ...row, [params.field]: params.value }
                            : row
                        )
                      );
                    }}
                    hideFooter={true}
                    onCellEditStart={() => setIsEditing(true)}
                    onCellEditStop={() => setIsEditing(false)}
                    // onCellEditCommit={() => setIsEditing(false)}
                    // components={{
                    //   Toolbar: GridToolbar,
                    // }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} textAlign={"end"}>
                <Button
                  onClick={handleSave}
                  variant="contained"
                  disabled={isEditing || row.length == 0}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default MultiUserModal;
